<template>
  <div class="col-xs-12 col-xl-9 pl-0">
    <CreateRule />
  </div>
</template>

<script>
import CreateRule from '@/components/rules/CreateRule.vue'

export default {
  name: 'rules',
  data () {
    return {
    }
  },
  components: {
    CreateRule
  }
}
</script>

<style scoped>
</style>
